import { Button, Layout, Space, Spin, message } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { StopOutlined, SaveOutlined } from '@ant-design/icons'
import { useHistory, useLocation, useParams } from 'react-router'
import { useEffect, useState } from 'react'
import { Editor, Toolbar } from '@wangeditor/editor-for-react'
import NavHeader from '../../../../components/NavHeader'
import AxiosUtil from '../../../../utils/AxiosUtil'
import type { IDomEditor, IEditorConfig, IToolbarConfig } from '@wangeditor/editor'
import styles from './helpEdit.module.less'
import '@wangeditor/editor/dist/css/style.css'

type ICatalogItem = {
  functionId: number
  functionName: string
  functionType: 2
  announcementId: number
  parentId?: number
  sortIndex?: null
  announcementcontentid?: number
  flag: 1 | 0
  children?: []
}
type IContentItem = { id?: number; summary: string; announcementId: number; flag: 1 | 0; functionId: number }
type InsertFnType = (url: string, alt: string, href: string) => void

const toolbarConfig: Partial<IToolbarConfig> = { excludeKeys: ['group-video', 'uploadVideo', 'insertVideo'] } // 工具栏配置
const headContentBoxId = 'header-container' // 大纲容器的 id

export default function HelpEdit() {
  const history = useHistory()
  const { state }: { state: ICatalogItem; pathname: string } = useLocation()
  const { id, parentId } = useParams<{ id: string; parentId: string }>()
  const [loading, setLoading] = useState(false)
  const [editor, setEditor] = useState<IDomEditor | null>(null)
  const [textAreaValue, setTextAreaValue] = useState(+parentId ? '' : state?.functionName || '')
  const [ctx, setCtx] = useState<IContentItem>({
    summary: '',
    announcementId: +id,
    flag: 1,
    functionId: state?.functionId,
    id: +parentId ? 0 : state?.announcementcontentid,
  })

  // 编辑器配置
  const editorConfig: Partial<IEditorConfig> = {
    placeholder: '请输入内容...',
    MENU_CONF: {
      uploadImage: {
        base64LimitSize: 10 * 1024,
        customUpload: async (file: File, insertFn: InsertFnType) => {
          const formData = new FormData()
          formData.append('file', file)
          formData.append('announcementId', id)
          AxiosUtil.AxiosRequest('/api/announcement/importImg', formData, (suc, dat) => {
            if (suc) dat.list.map((item: { url: string; alt: string }) => insertFn(item.url, item.alt, item.url))
          })
        },
      },
    },
  }
  /** 富文本编辑器变化时的回调 (更新富文本编辑器, 更新大纲) */
  const editorOnChange = (editor: IDomEditor) => {
    setCtx({ ...ctx, summary: editor.getHtml() })
    const headers = editor.getElemsByTypePrefix('header')
    const headerContainer = document.getElementById('header-container')!
    headerContainer.innerHTML =
      headers
        ?.map((header: any) => {
          const { id, type } = header
          const text = header.children.map((i: { text: any }) => i.text)
          return `<li id="${id}" type="${type}">${text}</li>`
        })
        ?.join('') || ''
  }
  /** 点击大纲项的回调 (页面到对应标题位置) */
  const outlineOnClick = (e: any) => {
    if (e.target.tagName !== 'LI') return
    e.preventDefault()
    const id = e.target.id
    editor?.scrollToElem(id)
  }
  /* 点击取消 */
  const onCancel = () => history.push({ pathname: '/admin/help/' + id, state })
  /* 修改完成的回调 */
  const onFinish = () => {
    setLoading(true)
    if (!textAreaValue) {
      message.warning('请输入标题 !')
      setLoading(false)
    } else {
      const functionName = textAreaValue ? textAreaValue : '无标题文档'
      const params = +parentId
        ? { functionName, functionType: 2, flag: 1, announcementId: id, parentId: +parentId }
        : { ...state, functionName, functionType: 2, flag: 1, announcementId: id }
      AxiosUtil.AxiosRequest('/api/announcement/editAnnfunction', { list: [params] }, (suc, dat) => {
        if (suc) {
          AxiosUtil.AxiosRequest('/api/announcement/editAnnContent', { list: [{ ...ctx, functionId: dat.list[0].functionId }] }, (suc, d) => {
            suc && message.success((state.functionId ? '修改' : '新增') + '成功 !')
            setLoading(false)
            suc && history.push({ pathname: '/admin/help/' + id, state: { ...dat.list[0], announcementcontentid: d.list[0].id } })
          })
        } else setLoading(false)
      })
    }
  }

  /* 获取当前目录对应的在线文档内容 */
  useEffect(() => {
    state?.announcementcontentid &&
      !+parentId &&
      AxiosUtil.AxiosRequest('/api/announcement/getAnnContentInfo', { id: state?.announcementcontentid }, (suc, dat) => suc && setCtx(dat))
  }, [parentId, state?.announcementcontentid])
  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (!editor) return
      editor.destroy()
      setEditor(null)
    }
  }, [editor])

  return (
    <Layout>
      <NavHeader />
      <Spin spinning={loading}>
        <div id={styles.helpDocEdit}>
          <div className={'context-box'}>
            <TextArea
              rows={1}
              value={textAreaValue}
              placeholder={'请输入标题 !'}
              className={'catalog-title'}
              onChange={(e) => setTextAreaValue(e.target.value)}
            />
            <Toolbar mode="default" editor={editor} className={'context-toolbar-box'} defaultConfig={toolbarConfig} />
            <Editor
              value={ctx.summary}
              onCreated={setEditor}
              onChange={editorOnChange}
              defaultConfig={editorConfig}
              className={'context-editor-box'}
            />
          </div>
          {/* <!-- 标题目录 --> */}
          <div className={'catalog'}>
            <Space size={'middle'} className={'operate'}>
              <Button size={'small'} icon={<StopOutlined />} onClick={onCancel}>
                取消
              </Button>
              <Button size={'small'} icon={<SaveOutlined />} onClick={onFinish}>
                完成
              </Button>
            </Space>
            <div className={'directory-title'}>目录</div>
            <ul id={headContentBoxId} onMouseDown={outlineOnClick} />
          </div>
        </div>
      </Spin>
    </Layout>
  )
}
